import { useState } from "react";
import { motion, AnimatePresence } from "motion/react";
import { useTranslation } from "react-i18next";
import { Plus } from "lucide-react";
import { FAQ_KEYS } from "@/data/landing";
import { fadeUp, stagger, viewportOnce } from "./motion-presets";

export const FAQSection = () => {
  const { t } = useTranslation("landing");
  const [open, setOpen] = useState<number | null>(0);

  return (
    <section className="relative py-24 px-4">
      <motion.div
        initial="hidden"
        whileInView="visible"
        viewport={viewportOnce}
        variants={stagger}
        className="container mx-auto max-w-3xl"
      >
        <div className="text-center mb-12">
          <motion.span
            variants={fadeUp}
            className="text-xs font-medium uppercase tracking-wider text-muted-foreground"
          >
            {t("faq.eyebrow")}
          </motion.span>
          <motion.h2
            variants={fadeUp}
            className="mt-3 font-display text-3xl md:text-5xl font-semibold tracking-tight text-foreground"
          >
            {t("faq.title")}
          </motion.h2>
        </div>

        <div className="space-y-2">
          {FAQ_KEYS.map((key, i) => {
            const isOpen = open === i;
            return (
              <motion.div
                key={key}
                variants={fadeUp}
                className="rounded-xl border border-border bg-card/30 overflow-hidden"
              >
                <button
                  className="w-full flex items-center justify-between gap-4 px-5 py-4 text-left text-[15px] font-medium text-foreground/90 hover:text-foreground transition-colors"
                  onClick={() => setOpen(isOpen ? null : i)}
                  aria-expanded={isOpen}
                >
                  <span>{t(`faq.items.${key}.q`)}</span>
                  <motion.span
                    animate={{ rotate: isOpen ? 45 : 0 }}
                    transition={{ duration: 0.2 }}
                    className="flex-shrink-0 text-muted-foreground"
                  >
                    <Plus className="h-4 w-4" />
                  </motion.span>
                </button>
                <AnimatePresence initial={false}>
                  {isOpen && (
                    <motion.div
                      initial={{ height: 0, opacity: 0 }}
                      animate={{ height: "auto", opacity: 1 }}
                      exit={{ height: 0, opacity: 0 }}
                      transition={{ duration: 0.25, ease: [0.22, 1, 0.36, 1] }}
                      className="overflow-hidden"
                    >
                      <p className="px-5 pb-5 text-sm text-muted-foreground leading-relaxed">
                        {t(`faq.items.${key}.a`)}
                      </p>
                    </motion.div>
                  )}
                </AnimatePresence>
              </motion.div>
            );
          })}
        </div>
      </motion.div>
    </section>
  );
};
